import React from "react";
import { useTranslation } from "react-i18next";
import Box from "@mui/material/Box";
import { useTheme } from "@mui/material/styles";
import { MyTimeWorkingFrameBox } from "my-time/components";
import { useMyTimeFramePeriod } from "my-time/hooks";

interface MyTimeWorkingTimeFrameProps {
  contractCode: string;
  year: number;
  month: number;
  minHeight?: number | string;
}

export const MyTimeWorkingTimeFrame: React.FC<MyTimeWorkingTimeFrameProps> = ({
  contractCode,
  year,
  month,
  minHeight,
}) => {
  const theme = useTheme();
  const { t } = useTranslation();

  const { data, loading } = useMyTimeFramePeriod({
    contractCode,
    year: year,
    month: month,
  });

  const formatValue = (value: number) => {
    if (value % 1 !== 0) {
      const formattedValue = value?.toFixed(3);
      return formattedValue?.endsWith("00")
        ? Number.parseFloat(formattedValue)?.toFixed(1)
        : formattedValue;
    } else {
      return value?.toString();
    }
  };

  const mergedValue = formatValue(data?.hoursByFact) + " / " + data?.hoursByLaw;

  return (
    <Box>
      <Box>
        <MyTimeWorkingFrameBox
          label={`${t("MY_TIME_WORKED_TIME_FRAME")} / ${t("MY_TIME_WORK_TIME_FRAME")}`}
          value={mergedValue}
          color={theme.palette.greenBase.main}
          loading={loading || !data}
          framePeriodData={data}
          typeName="framePeriod"
          minHeight={minHeight}
        />
      </Box>
    </Box>
  );
};

export default MyTimeWorkingTimeFrame;
